import { render, staticRenderFns } from "./BracketsShuffleButton.vue?vue&type=template&id=610a75c8"
import script from "./BracketsShuffleButton.vue?vue&type=script&lang=js"
export * from "./BracketsShuffleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports